module.exports = __webpack_public_path__ + "static/media/kotlin.654b5877.svg";